// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__3dpT_","header":"Section_header__3Q5Nm","content":"Section_content__1w5Ud"};